export const NotFoundIllustration = () => {
    return (
        <svg
            width="135"
            height="64"
            viewBox="0 0 135 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M57.6665 29.5288C64.4732 29.5288 69.9999 35.0923 69.9999 41.9444V61.7421H45.3332V41.9444C45.3332 35.0923 50.8599 29.5288 57.6665 29.5288Z"
                fill="#113064"
            />
            <path
                d="M95.8466 57.0445C95.8466 58.6551 95.6633 60.2289 95.3133 61.7423H47.7133C47.3633 60.2289 47.1799 58.6551 47.1799 57.0445C47.1799 44.6289 58.0766 34.5623 71.5133 34.5623C84.9499 34.5623 95.8466 44.6289 95.8466 57.0445Z"
                fill="#CC8466"
            />
            <path
                d="M78 20.469V61.7423H70V41.9445C70 38.5152 68.62 35.4146 66.3867 33.1664C64.1534 30.9182 61.0734 29.529 57.6667 29.529C50.8567 29.529 45.3334 35.0891 45.3334 41.9445V61.7423H37.3334V20.469H78Z"
                fill="#B5DEFF"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M135 63.0844H0V61.7422H135V63.0844Z"
                fill="#113064"
            />
            <path d="M114 20.469H77.9999V61.7423H114V20.469Z" fill="#0265DC" />
            <path
                d="M60.3332 29.8207C54.8065 31.0455 50.6665 36.0117 50.6665 41.9444V61.7421H45.3332V41.9444C45.3332 35.089 50.8565 29.5288 57.6665 29.5288C58.5832 29.5288 59.4732 29.6295 60.3332 29.8207Z"
                fill="#FFB2A0"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M57.6664 25.5022C49.0743 25.5022 41.6664 32.3629 41.6664 39.9311V57.3799H40.9998V39.9311C40.9998 31.9294 48.7718 24.8311 57.6664 24.8311C66.561 24.8311 74.3331 31.9294 74.3331 39.9311V57.3799H73.6664V39.9311C73.6664 32.3629 66.2585 25.5022 57.6664 25.5022Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M57.6667 29.8645C51.0408 29.8645 45.6667 35.2744 45.6667 41.9445V61.7422H45.0001V41.9445C45.0001 34.9037 50.6726 29.1934 57.6667 29.1934C64.6608 29.1934 70.3334 34.9037 70.3334 41.9445V61.7422H69.6667V41.9445C69.6667 35.2744 64.2926 29.8645 57.6667 29.8645Z"
                fill="#113064"
            />
            <path d="M109.667 28.8577H82.3332V48.3199H109.667V28.8577Z" fill="#B5DEFF" />
            <path
                d="M92.7567 31.8777C92.7567 32.0455 92.75 32.2132 92.7367 32.3844C92.53 35.2265 90.57 37.5821 87.9233 38.3841C87.6833 38.4579 87.44 38.5183 87.1867 38.5653C87.3633 38.6559 87.53 38.7666 87.6867 38.8874C88.49 39.5082 89.0033 40.478 89.0033 41.5685V45.2999H85.3367V31.8777H92.76H92.7567Z"
                fill="#FFB2A0"
            />
            <path
                d="M99.243 31.8777C99.243 32.0455 99.2497 32.2132 99.263 32.3844C99.4697 35.2265 101.43 37.5821 104.076 38.3841C104.316 38.4579 104.56 38.5183 104.813 38.5653C104.636 38.6559 104.47 38.7666 104.313 38.8874C103.51 39.5082 102.996 40.478 102.996 41.5685V45.2999H106.663V31.8777H99.2397H99.243Z"
                fill="#FFB2A0"
            />
            <path d="M37.3334 20.4688L58 2.68433L78 20.4688H37.3334Z" fill="#B5DEFF" />
            <path d="M54.3334 0L58 2.68444L37.3334 20.4689H30.6667L54.3334 0Z" fill="#0265DC" />
            <path d="M54.3333 0H94.3333L118.08 20.4689H78L54.3333 0Z" fill="#113064" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M114 57.3801H77.9999V56.709H114V57.3801Z"
                fill="#113064"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M78.0001 57.3801H70.3334V56.709H78.0001V57.3801Z"
                fill="white"
            />
            <path d="M37.3334 57.0444H45" stroke="white" stroke-width="2" stroke-miterlimit="10" />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M108.333 30.8711H83.9999V30.2H108.333V30.8711Z"
                fill="#113064"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M108.333 38.9243H83.9999V38.2532H108.333V38.9243Z"
                fill="#113064"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M108.333 46.9778H83.9999V46.3066H108.333V46.9778Z"
                fill="#113064"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M83.6666 46.9777V30.2H84.3332V46.9777H83.6666Z"
                fill="#113064"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M95.9997 46.9777V30.2H96.6664V46.9777H95.9997Z"
                fill="#113064"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M107.667 46.9777V30.2H108.333V46.9777H107.667Z"
                fill="#113064"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M57.6666 11.2971L68.3823 20.8044H46.9509L57.6666 11.2971ZM48.7156 20.1333H66.6176L57.6666 12.1917L48.7156 20.1333Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M44.0001 20.1333H71.3334V20.8044H44.0001V20.1333Z"
                fill="white"
            />
            <path
                d="M45.0001 34.2266H32.8301C31.5701 34.2266 30.3934 34.844 29.6868 35.8741L23.8601 44.3603C22.4134 46.4676 22.9701 49.3366 25.1034 50.7661C27.2368 52.1956 30.1401 51.6453 31.5868 49.538L38.5468 39.4042L36.3268 37.9177H45.0001V34.2266Z"
                fill="#6A302D"
            />
            <path
                d="M41.3333 34.2266H55.3333C56.4366 34.2266 57.3333 35.1292 57.3333 36.2399V61.7421H29.3333V46.3066C29.3333 39.6391 34.71 34.2266 41.3333 34.2266Z"
                fill="#CC8466"
            />
            <path
                d="M23.9999 53.689H42.9999V61.7423H15.9999C15.9999 57.2962 19.5832 53.689 23.9999 53.689Z"
                fill="#CC8466"
            />
            <path
                d="M29.9999 47.6489H53.9999V61.7423H25.9999C23.7932 61.7423 21.9999 59.937 21.9999 57.7156V55.7023C21.9999 51.2561 25.5832 47.6489 29.9999 47.6489Z"
                fill="#CC8466"
            />
            <path
                d="M41.8333 49.9977C44.8709 49.9977 47.3333 47.5188 47.3333 44.461C47.3333 41.4032 44.8709 38.9243 41.8333 38.9243C38.7957 38.9243 36.3333 41.4032 36.3333 44.461C36.3333 47.5188 38.7957 49.9977 41.8333 49.9977Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M30.0001 47.9843C25.7599 47.9843 22.3334 51.3617 22.3334 55.5109V57.4772C22.3334 59.4552 23.9664 61.071 26.0001 61.071H29.3334V61.7421H26.0001C23.6137 61.7421 21.6667 59.8413 21.6667 57.4772V55.5109C21.6667 50.9758 25.407 47.3132 30.0001 47.3132H36.3334V47.9843H30.0001Z"
                fill="#6A302D"
            />
            <path
                d="M57.3335 36.2399V47.1455C57.3335 49.8299 55.1701 52.011 52.5001 52.011C49.8301 52.011 47.6668 49.8299 47.6668 47.1455V34.2266H55.3335C56.4368 34.2266 57.3335 35.1259 57.3335 36.2399Z"
                fill="#6A302D"
            />
            <path
                d="M32.6665 45.6356C33.4028 45.6356 33.9998 45.0347 33.9998 44.2934C33.9998 43.5521 33.4028 42.9512 32.6665 42.9512C31.9301 42.9512 31.3331 43.5521 31.3331 44.2934C31.3331 45.0347 31.9301 45.6356 32.6665 45.6356Z"
                fill="#2D2E31"
            />
            <path
                d="M35.26 44.4275C35.26 45.4913 34.4767 46.3771 33.46 46.5214C33.41 46.3268 33.37 46.1322 33.3333 45.9375C33.1167 44.7295 33.1667 43.5014 33.46 42.3303C34.4767 42.478 35.26 43.3605 35.26 44.4242V44.4275Z"
                fill="#2D2E31"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27 55.0309C27 54.2061 26.6733 53.4609 26.1423 52.9173L26.6176 52.4468C27.2667 53.1112 27.6666 54.0237 27.6666 55.0309C27.6666 57.0685 26.0241 58.722 24 58.722V58.0509C25.6559 58.0509 27 56.6979 27 55.0309Z"
                fill="#6A302D"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M27.0001 55.0309C27.0001 54.0237 27.4 53.1112 28.0491 52.4468L28.5244 52.9173C27.9935 53.4609 27.6668 54.2061 27.6668 55.0309C27.6668 56.6979 29.0109 58.0509 30.6668 58.0509V58.722C28.6427 58.722 27.0001 57.0685 27.0001 55.0309Z"
                fill="#6A302D"
            />
            <path
                d="M29.3867 53.2191L27.72 54.417C27.4867 54.5848 27.1767 54.5848 26.9467 54.417L25.28 53.2191C25.1034 53.0916 25 52.8902 25 52.6721V52.3466C25 51.9775 25.3 51.6755 25.6667 51.6755H29C29.3667 51.6755 29.6667 51.9775 29.6667 52.3466V52.6721C29.6667 52.8902 29.5634 53.0916 29.3867 53.2191Z"
                fill="#6A302D"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M41.8331 34.8978C36.5864 34.8978 32.3331 39.1794 32.3331 44.4611C32.3331 49.7428 36.5864 54.0244 41.8331 54.0244C47.0798 54.0244 51.3331 49.7428 51.3331 44.4611C51.3331 39.1794 47.0798 34.8978 41.8331 34.8978ZM31.3331 44.4611C31.3331 38.6235 36.0341 33.8911 41.8331 33.8911C47.6321 33.8911 52.3331 38.6235 52.3331 44.4611C52.3331 50.2988 47.6321 55.0311 41.8331 55.0311C36.0341 55.0311 31.3331 50.2988 31.3331 44.4611Z"
                fill="#113064"
            />
            <path
                d="M44.0264 44.6491C44.1497 43.3572 43.2097 42.2096 41.9264 42.0888C40.6431 41.968 39.5064 42.9109 39.3831 44.2028C39.2597 45.4947 40.1997 46.6389 41.4831 46.7631C42.7664 46.8872 43.9064 45.941 44.0297 44.6491H44.0264Z"
                fill="#2D2E31"
            />
            <path
                d="M42.8331 43.9577C43.8456 43.9577 44.6664 43.1314 44.6664 42.1122C44.6664 41.0929 43.8456 40.2666 42.8331 40.2666C41.8206 40.2666 40.9998 41.0929 40.9998 42.1122C40.9998 43.1314 41.8206 43.9577 42.8331 43.9577Z"
                fill="white"
            />
            <path
                d="M44.6667 40.9376C45.219 40.9376 45.6667 40.4869 45.6667 39.931C45.6667 39.375 45.219 38.9243 44.6667 38.9243C44.1144 38.9243 43.6667 39.375 43.6667 39.931C43.6667 40.4869 44.1144 40.9376 44.6667 40.9376Z"
                fill="white"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M49.8076 59.1397L45.974 53.6491L46.7922 53.0702L50.6257 58.5608L49.8076 59.1397Z"
                fill="#113064"
            />
            <path
                d="M55.3333 53.689H67.6666V61.7423H47.3333C47.3333 57.2962 50.9166 53.689 55.3333 53.689Z"
                fill="#CC8466"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M55.3333 54.0244C51.1007 54.0244 47.6666 57.4814 47.6666 61.7422H46.9999C46.9999 57.1107 50.7325 53.3533 55.3333 53.3533H67.6666V54.0244H55.3333Z"
                fill="#6A302D"
            />
            <path
                opacity="0.5"
                d="M41.8332 53.0176C46.5276 53.0176 50.3332 49.1867 50.3332 44.461C50.3332 39.7352 46.5276 35.9043 41.8332 35.9043C37.1388 35.9043 33.3332 39.7352 33.3332 44.461C33.3332 49.1867 37.1388 53.0176 41.8332 53.0176Z"
                fill="white"
            />
        </svg>
    );
};
